
import { TripInfoMutation, TripMutation } from '@clients/myTrips' // eslint-disable-line no-unused-vars
import { deepEquals } from '@util/copy' // eslint-disable-line no-unused-vars
import { error } from 'util' // eslint-disable-line no-unused-vars

/* eslint-disable no-undef */
export enum TripDetailsError {
  MISSING_START_ADDRESS = 'Die Adresse der Startposition ist erforderlich.',
  MISSING_START_ODOMETER = 'Der Km-Stand der Startposition ist erforderlich.',
  MISSING_START_DATETIME = 'Der Zeitpunkt der Startposition ist erforderlich.',
  MISSING_END_ADDRESS = 'Die Adresse der Endposition ist erforderlich.',
  MISSING_END_ODOMETER = 'Der Km-Stand der Endposition ist erforderlich.',
  MISSING_END_DATETIME = 'Der Zeitpunkt der Endposition ist erforderlich.',
  EMPTY_STOP_FIELD = 'Die Adresse eines Zwischenstopps darf nicht leer sein.',
  DUPLICATE_STOP_FIELDS = 'Aufeinanderfolgende Zwischenstopps dürfen nicht die gleiche Adresse haben.',
  MISSING_REQUIRED_NOTE = 'Bei einer beruflichen Fahrt ist die Beschreibung erforderlich.'
}

export function getTripDetailError (trip: TripMutation): TripDetailsError[] {
  if (trip) {
    return [ ...startErrors(trip), ...endErrors(trip), ...stopSectionError(trip), ...requiredNoteError(trip), ...consecutiveStopDuplicateError(trip) ]
  }
  return []
}

function stopSectionError (trip: TripMutation): TripDetailsError[] {
  return trip.stops.filter(s => !s).length > 0 ? [TripDetailsError.EMPTY_STOP_FIELD] : []
}

function consecutiveStopDuplicateError (trip: TripMutation): TripDetailsError[] {
  return trip.stops.filter(s => s).filter((s, i) => i > 0 && deepEquals(s.location, trip.stops[i - 1].location)).length > 0
    ? [TripDetailsError.DUPLICATE_STOP_FIELDS] : []
}

function startErrors (trip: TripMutation): TripDetailsError[] {
  return infoErrors(trip.startInfo, true)
}

function endErrors (trip: TripMutation): TripDetailsError[] {
  return infoErrors(trip.endInfo, false)
}

function infoErrors (tripInfo: TripInfoMutation, startPos: boolean) {
  const errors = []

  if (!tripInfo.address || !tripInfo.address.moniker) {
    errors.push(startPos ? TripDetailsError.MISSING_START_ADDRESS : TripDetailsError.MISSING_END_ADDRESS)
  }

  if (!tripInfo.odometer && tripInfo.odometer !== 0) {
    errors.push(startPos ? TripDetailsError.MISSING_START_ODOMETER : TripDetailsError.MISSING_END_ODOMETER)
  }

  if (!tripInfo.timestamp) {
    errors.push(startPos ? TripDetailsError.MISSING_START_DATETIME : TripDetailsError.MISSING_END_DATETIME)
  }

  return errors
}

function requiredNoteError (trip: TripMutation): TripDetailsError[] {
  return trip.work && (!trip.note || !trip.note.trim()) ? [TripDetailsError.MISSING_REQUIRED_NOTE] : []
}
